import React from "react";

import useStyles from "../../../style/js-style/containers/thirdparties/unmanagedThirdParty/CreateUnmanagedThirdPartyStyle";
import i18next from "i18next";
import EAIcon from "components/common/EAIcon";

const UnmanagedBadge = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.thirdPartyUnmanaged}>
      <EAIcon icon={"unmanagedThirdParty/unmanagedTP"} className={classes.unmanagedIcon} />
      <div className={classes.unmanagedTitle} >
        {i18next.t('unmanagedThirdParty.NotManaged')}
      </div>
    </div>
  )
};
export default UnmanagedBadge;